import { RoleTypes, IModuleRoute, AppRouteNamesList } from 'models';
import { CONSTANTS } from 'utils';

const clientRequiredRoles = [RoleTypes.PRIMARY_ADMIN, RoleTypes.ADMIN];

enum ClientsPathList {
	clients = '/clients',
	new = '/new',
	details = '/details',
	edit = '/details/edit',
}

export const clientsRoutes: IModuleRoute = {
	path: `${CONSTANTS.moduleAdminPath}${ClientsPathList.clients}`,
	name: AppRouteNamesList.clients,
	requiredRoles: clientRequiredRoles,
	nested: [
		{
			path: ClientsPathList.new,
			name: AppRouteNamesList.clientsNew,
			requiredRoles: clientRequiredRoles,
		},
		{
			path: ClientsPathList.details,
			name: AppRouteNamesList.clientsDetails,
			requiredRoles: clientRequiredRoles,
		},
		{
			path: ClientsPathList.edit,
			name: AppRouteNamesList.clientsEdit,
			requiredRoles: clientRequiredRoles,
		},
	],
};
